import React from 'react';

const SubscriptionDetailModal = ({ setDetailModal, userDetails }) => {

  console.log('this is in subscription detail', userDetails);

  // Function to format dates as 'YYYY-MM-DD'
  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Get the subscription status text based on the status code
  const getSubscriptionStatusText = (status) => {
    switch (status) {
      case 1:
        return 'Active';
      case 2:
        return 'Canceled';
      case 3:
        return 'Expired';
      default:
        return 'N/A';
    }
  };

  return (
    <div>
      <div className='detail-page-modal'>
      <div className='modal-header'>
                <h3>Subscription Details</h3>
                <button className='close-button' onClick={() => setDetailModal(false)}><img src={window.getPublicUrl("/assets/images/gray-cross.svg")} alt='' /></button>

            </div>
     {/* <button className='close-button' onClick={() => setDetailModal(false)}><img src={window.getPublicUrl("/assets/images/gray-cross.svg")} alt='' /></button>
      <h2>Subscription Details</h2> */}
      <ul>
        <li><strong>Payment Date:</strong> {formatDate(userDetails?.createdAt)}</li>
        <li><strong>Payment Id:</strong> {userDetails?.id || 'N/A'}</li>
        <li><strong>Subscription End Date:</strong> {formatDate(userDetails?.subscription_end)}</li>
        
        {/* Only show Subscription Expired At if the status is 2 (Canceled) */}
        {userDetails?.subscription_status === 2 && (
          <li><strong>Subscription Expired At:</strong> {formatDate(userDetails?.subscription_expired_at)}</li>
        )}

        <li><strong>Subscription Start Date:</strong> {formatDate(userDetails?.subscription_start)}</li>
        
        {/* Subscription Status with dynamic text */}
        <li><strong>Subscription Status:</strong> {getSubscriptionStatusText(userDetails?.subscription_status)}</li>
        
        <li><strong>Subscription Type:</strong> {userDetails?.subscription_type || 'N/A'}</li>
      </ul>
    </div>
    </div>
  );
};

export default SubscriptionDetailModal;
